import { render, staticRenderFns } from "./BaseFieldSet.vue?vue&type=template&id=2e0e6df6"
import script from "./BaseFieldSet.vue?vue&type=script&lang=js"
export * from "./BaseFieldSet.vue?vue&type=script&lang=js"
import style0 from "./BaseFieldSet.vue?vue&type=style&index=0&id=2e0e6df6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports